// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.select-section__desc{font-size:12px;margin-top:20px;text-align:center}.select-section__footer{margin-top:20px;text-align:center}`, "",{"version":3,"sources":["webpack://./src/modals/common/SelectSection/style.scss"],"names":[],"mappings":"AAEE,sBACE,cAAA,CACA,eAAA,CACA,iBAAA,CAGF,wBACE,eAAA,CACA,iBAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
